/**
 * 建群页懒加载壳（14.23b；FriendGroupsLazy 同构）：低频管理页不进首屏 bundle。
 */
import { useLazyModule } from './useLazyModule';

export function CreateGroupLazy() {
  const { mod } = useLazyModule(() => import('./CreateGroupPage'));
  if (mod === null) return <div data-testid="create-group-loading-shell">加载中…</div>;
  return <mod.CreateGroupPage />;
}
